export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=707a6bbb2955099905ca6330f850a4b13f25e25c6d&name=pushAdClickData!'